import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { View, Text } from "./base";
import { Icon } from "./base/Icon";
import { useApiRequest } from "../hooks/useApiRequest";
import { useEffectiveOrganization } from "../hooks/useEffectiveOrganization";

type BalanceResponse = {
  data: {
    balance: number;
    organizationId: string;
  };
};

export const LowBalanceBanner = () => {
  const { organizationId, organization } = useEffectiveOrganization();
  const balanceRequest = useApiRequest<BalanceResponse>();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (organizationId && organization?.billingEnabled) {
      balanceRequest.fetch(`/v1/credits/balance?organizationId=${organizationId}`);
    }
  }, [organizationId, organization?.billingEnabled]);

  if (!organization?.billingEnabled) {
    return null;
  }

  const balance = balanceRequest.data?.data?.balance ?? null;

  if (dismissed || balance === null || balance > 0) {
    return null;
  }

  return (
    <View className="flex flex-row items-center justify-between px-4 py-2.5 bg-amber-50 dark:bg-amber-950/40 border-b border-amber-200 dark:border-amber-800">
      <View className="flex flex-row items-center gap-2">
        <Icon
          name="warning-amber"
          size={16}
          className="text-amber-600 dark:text-amber-400 shrink-0"
        />
        <Text className="text-sm text-amber-800 dark:text-amber-200">
          Your organization has no remaining credits.{" "}
          <button
            onClick={() => navigate("/organization/billing")}
            className="font-medium underline hover:no-underline"
          >
            Add funds
          </button>{" "}
          to continue using the platform.
        </Text>
      </View>
      <button
        onClick={() => setDismissed(true)}
        className="text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200 shrink-0 ml-2"
      >
        <Icon
          name="close"
          size={16}
        />
      </button>
    </View>
  );
};
